export default {
    edit: {
        path: require('@/assets/global-icons/edit.svg'),
    },
    lock: {
        path: require('@/assets/global-icons/lock.svg'),
    },
    clock: {
        path: require('@/assets/global-icons/clock.svg'),
    },
    user: {
        path: require('@/assets/global-icons/user.svg'),
    },
    delete: {
        path: require('@/assets/global-icons/cross-red-circle.svg'),
        size: "20px"
    },
    add: {
        path: require('@/assets/global-icons/add-green.svg'),
        size: "16px"
    },
    broadcast: {
        path: require('@/assets/notification-icons/broadcast.svg'),
        size: "16px"
    },
    cohost: {
        path: require('@/assets/conferencing-icons/co-host.svg'),
        size: "20px"
    },
    download: {
        path: require('@/assets/global-icons/download.svg'),
        size: "20px"
    }
}
